import { observable } from "../../r-html/dist/observable/index.js";
import { getSceneContentRect } from "./contentBounds.js";
import { getSceneTransform } from "./viewport.js";
//#region src/konva/scene/viewFreeze.ts
var state = observable({ frozen: {} });
var sceneKeyOf = (root, source) => `${root.editor.id}:${source}`;
var frozenOf = (root, source) => state.frozen[sceneKeyOf(root, source)] ?? null;
function freezeView(root, source = "document") {
	const { originX, originY } = getSceneTransform(root, source);
	state.frozen[sceneKeyOf(root, source)] = {
		content: getSceneContentRect(root, source),
		origin: {
			x: originX,
			y: originY
		}
	};
}
function thawView(root, source = "document") {
	Reflect.deleteProperty(state.frozen, sceneKeyOf(root, source));
}
function getViewContentRect(root, source = "document") {
	const frozen = frozenOf(root, source);
	return frozen ? frozen.content : getSceneContentRect(root, source);
}
function getFrozenOrigin(root, source = "document") {
	return frozenOf(root, source)?.origin ?? null;
}
//#endregion
export { freezeView, getFrozenOrigin, getViewContentRect, sceneKeyOf, thawView };
